import { Icon } from '@docs/kd-d2c-components';
import { FileHelper } from '@src/utils/file';
import { ATTACHMENT_SUPPORT_TYPE } from '@src/components/common/md-render/constants';
import './attachment.less';
import { useComputerData } from '@src/stores/useComputerData';
import { isKim, isMobile } from '@/utils/user-agent';
const getAttachmentTypeOptions = (suffix: string) => {
  const ext = suffix.startsWith('.') ? suffix : '.' + suffix;
  return ATTACHMENT_SUPPORT_TYPE.find((item) => item.reg.test(ext));
};
interface AttachmentProps {
  suffix?: string;
  id: string;
  title: string;
  size?: string;
  pdfKey?: string;
  fileUrl?: string;
}
const Attachment = ({
  suffix,
  id,
  title,
  size,
  pdfKey,
  fileUrl,
}: AttachmentProps) => {
  const { icon } = getAttachmentTypeOptions(suffix || '') || {};
  const { activeFile } = useComputerData();

  const handleClick = () => {
    if (isMobile) {
      return FileHelper.previewFileInKim({
        type: suffix || '',
        url: fileUrl || '',
        downloadUrl: FileHelper.getDownloadUrl(id || ''),
        size: Number(size || 0),
        name: title,
        blobKey: id,
      });
    }
    activeFile({
      fileId: id,
      fileExtension: suffix || '',
      fileName: title,
      fileSize: Number(size || 0),
      pdfKey,
      fileUrl,
    });
  };

  if (FileHelper.isImage(suffix || '') && fileUrl) {
    return (
      <div className="im-image" onClick={handleClick}>
        <img src={fileUrl} />
      </div>
    );
  }

  return (
    <div className="im-attachment" onClick={handleClick}>
      <Icon className="im-attachment-icon" icon={icon as [string]} />
      <div className="im-attachment-content">
        <div className="im-attachment-title">{decodeURIComponent(title)}</div>
        <div className="im-attachment-info">
          {size ? (
            <div className="im-attachment-size">
              {FileHelper.getSize(Number(size || 0))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Attachment;
